import { getFinalPrice } from '@kissui/plp/services'
import { isBundled } from '@kissui/helpers/src/catalog'
import { getMaxIntensity } from '@kissui/components/src/sku-coffee/services'

export const getMergedProductCoffeeData = (
    product,
    pageBuilderProductProps,
    pageBuilderProps,
    priceFormatter,
    currency
) => {
    const { bundle_details } = pageBuilderProductProps
    const { options } = pageBuilderProps
    const { show_sleeve_price } = options

    const isBundledResult = isBundled(product)

    const { showCapsulePrice, price_per_capsule, final_price } = getFinalPrice(
        show_sleeve_price,
        product,
        isBundled
    )

    const option = {
        bundled: isBundledResult,
        intensity: product.capsuleProperties?.intensity || product.intensity || null,
        max_intensity: getMaxIntensity(product),
        price_per_capsule: price_per_capsule
            ? priceFormatter.short(currency, price_per_capsule)
            : null,
        show_capsule_price: showCapsulePrice
    }

    if (show_sleeve_price) {
        option.price = priceFormatter.short(currency, final_price)
    }

    if (bundle_details) {
        option.bundle_details = bundle_details
    }

    return option
}
